<template>
    <div class="form-item form-item-select">
        <label class="form-label">Filter by type</label>
        <div class="select-outer">
            <input type="text"
                   name="filter-type"
                   v-model="selectedValue"
                   @focus="openList = true"
                   @blur="openList = hoverList ? true : false"
                   :readonly="true">
            <ul v-show="openList">
                <li v-for="(type, index) in types"
                    :key="index"
                    @click="setItem(index, type), openList = false"
                    @mouseover="hoverList = true"
                    @mouseleave="hoverList = false">{{ type }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                openList        : false,
                hoverList       : false,
                filterValue     : 'NOT_CONFIGURED',
                selectedValue   : '--',
                types           : {
                    NOT_CONFIGURED  : '--',
                    mining          : 'From mining',
                    royal_bonus     : 'From Royal position'
                }
            }
        },
        methods: {
            setItem (filterValue, label) {
                this.selectedValue  = label
                this.filterValue    = filterValue
            }
        },
        watch: {
            filterValue () {
                if (this.filterValue !== 'NOT_CONFIGURED') {
                    this.$store.dispatch('transferHistorySetFilter', this.filterValue).then(() => {
                        this.$store.dispatch('loadTransferHistory', {
                            params: this.$store.getters.transferHistorySettings
                        })
                    })
                } else {
                    this.$store.commit('transferHistoryClearFilter')
                }
            }
        },
        beforeMount () {
            let filter = this.$store.getters.transferHistorySettings.filter.filter(function (obj) {
                return obj.value === 'type'
            })

            if (filter.length > 0 ) {
                this.filterValue   = filter[0].value
                this.selectedValue = this.types[filter[0].value]
            } else {
                this.filterValue   = 'NOT_CONFIGURED'
                this.selectedValue = this.types['NOT_CONFIGURED']
            }


        }
    }
</script>

<style lang="scss" scoped>
    .form-item{
        display: flex;
        align-items: center;
        justify-content: flex-start;

        label{
            white-space: nowrap;
        }

        .select-outer{
            margin-left: 11px;

            input{
                cursor: pointer;
                line-height: 28px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin-history/Type.vue